import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import InvoiceTableForMember from "./invoice-table";
import { MemberTableDatatypes } from "@/types/member";
import LinkedMembersTable from "./linked-members-table";
import { Button } from "@/components/ui/button";
import { InvoiceDetails } from "@/types/invoice";
import { useState } from "react";
import InvoiceForm from "@/components/admin/financials/modal/form";
import { InvoiceStatus, InvoiceType } from "@/types/enums";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
type BusinessDetailProps = {
  memberInfo: MemberTableDatatypes | undefined;
};

const MemberInvoice = ({ memberInfo }: BusinessDetailProps) => {
  const userInfo = useSelector((state: RootState) => state.auth.userInfo?.user);

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [editInvoiceData, setEditInvoiceData] = useState<
    InvoiceDetails | undefined
  >(undefined);

  const [action, setAction] = useState<"add" | "edit" | "member-created">("add");

  const handleOpenInvocieForm = () => {
    setAction("member-created")
    const invoicePayload = {
      org_id: userInfo?.org_id,
      invoice_number: "",
      member_id: memberInfo?.id,
      member_name: memberInfo?.first_name + " " + memberInfo?.last_name,
      member_email: memberInfo?.email as string,
      member_address: memberInfo?.address_1,
      member_nic: memberInfo?.nic,
      member_gender: memberInfo?.gender,
      is_business: memberInfo?.is_business,
      notes: "",
      total: 0,
      sub_total: 0,
      tax_amount: 0,
      discount: 0,
      status: InvoiceStatus.Pending,
      invoice_type: InvoiceType.Proforma,
      payment_date: new Date().toISOString(),
      id: 0,
      total_quantity: 0,
      items: [],
      seller_id: userInfo?.id,
      seller_name: userInfo?.first_name,
    };

    setEditInvoiceData(invoicePayload as InvoiceDetails);
    setIsDialogOpen(true);
  }

  return (
    <div>
      <Tabs defaultValue="invoice" className="w-full">
        <div className="w-full flex justify-between">
          <TabsList className="grid w-fit grid-cols-2">
            <TabsTrigger variant={"primary"} value="invoice">
              Invoices
            </TabsTrigger>
            <TabsTrigger variant={"primary"} value="linked-members">
              Linked Members
            </TabsTrigger>
          </TabsList>
          <div>
            <Button onClick={handleOpenInvocieForm} className="text-black">Create Invoice</Button>
          </div>
        </div>

        <Separator className="my-3 w-full" />

        <TabsContent className="w-full " value="invoice">
          <InvoiceTableForMember memberInfo={memberInfo} />
        </TabsContent>

        <TabsContent value="linked-members">
          <LinkedMembersTable memberInfo={memberInfo} />
        </TabsContent>
      </Tabs>

      <InvoiceForm
        isOpen={isDialogOpen}
        setOpen={setIsDialogOpen}
        action={action}
        setAction={setAction}
        refetch={() => { console.log("Member detail form") }}
        editModeData={editInvoiceData}
      />
    </div>
  );
};

export default MemberInvoice;
